<template>
  <div v-if="question && question.secQuestion">
    <div class="d-flex align-baseline">
      <label class="och-label">{{ question.secQuestion.text }}</label>
      <v-spacer></v-spacer>
      <help-text-dialog
        :question="question.secQuestion"
        :answerList="filterAnswerList(question.secQuestion.id)"
      ></help-text-dialog>
    </div>

    <v-select
      :hint="question.secQuestion.helpText"
      :items="filterAnswerList(question.secQuestion.id)"
      :rules="ruleList"
      class="mb-4"
      color="primary"
      hide-details
      item-value="id"
      outlined
      v-model="answer"
    ></v-select>
    <div v-if="answer">
      <div
        v-for="childQuestion in childQuestionList"
        :key="`parent${question.secQuestion.id}-${childQuestion.id}`"
      >
        <question-answer
          :answerMap="answerMap"
          :class="`ml-${indentation} child-question`"
          :depth="depth + 1"
          :question="{ secQuestion: childQuestion }"
        ></question-answer>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import HelpTextDialog from "./HelpTextDialog.vue";

export default {
  components: {
    HelpTextDialog,
  },
  computed: {
    answer: {
      get() {
        return this.answerMap[this.question.secQuestion.id];
      },
      set(val) {
        Vue.set(this.answerMap, this.question.secQuestion.id, val);
      },
    },
    childQuestionList() {
      if (!this.answer) return [];
      return this.filterQuestionList("parentAnswerId", this.answer);
    },
    indentation() {
      return this.depth * 4 + 4;
    },
    ...mapGetters({
      filterAnswerByAttribute: "secAnswer/filterByAttributeValue",
      filterQuestionList: "secQuestion/filterByAttributeValue",
    }),
  },
  data() {
    return {
      ruleList: [v => !!v || "Required field"],
    };
  },
  methods: {
    filterAnswerList(secQuestionId) {
      const filteredList = this.filterAnswerByAttribute(
        "secQuestionId",
        secQuestionId
      );

      const filteredListWithoutDeprecatedAnswers = filteredList.filter(
        item => !item.isDeprecated
      );
      return filteredListWithoutDeprecatedAnswers;
    },
    saveAnswer() {
      this.$emit("input", this.value);
    },
  },
  name: "question-answer",
  props: {
    answerMap: {
      type: Object,
    },
    depth: {
      type: Number,
      default: 0,
    },
    question: {
      type: Object,
    },
  },
  watch: {
    answer: async function (newVal, oldVal) {
      // If answer is found as a parentAnswerId in the question table,
      // delete the question and answer association from the answer map
      const oldChildQuestionList = this.filterQuestionList(
        "parentAnswerId",
        oldVal
      );

      const oldChildQuestionIdLIst = oldChildQuestionList.map(item => {
        return item.id;
      });

      for (const questionAnswerId of oldChildQuestionIdLIst) {
        delete this.answerMap[questionAnswerId];
      }
    },
  },
};
</script>

<style scoped>
.child-question {
  border-left: 15px solid #ddd !important;
  padding-left: 25px;
}
</style>
